// src/utils/mockDataCommercial.ts — Tier 4: Estimating, Contracts, Variations, Claims
// Note: all job IDs (j1-j6) are hardcoded as strings for referential consistency.

// ─────────────────────────────────────────────────────────────────
// SCOPE BRIEFS (tender pipeline)
// ─────────────────────────────────────────────────────────────────
export const MOCK_SCOPE_BRIEFS = [
  {
    id: 'sb1', briefNumber: 'SB-2026-008',
    title: 'Sherwood Rd / Oxley Rd Intersection — Full Signals Upgrade',
    clientId: 'c1', clientName: 'TMR Region 2', receivedFrom: 'Sarah Jones',
    receivedDate: '2026-06-01', submissionDeadline: '2026-07-04',
    method: 'PORTAL', siteAddress: 'Sherwood Rd & Oxley Rd, Sherwood QLD 4075',
    description: 'Full replacement of traffic signals including new poles, heads, controller, SCATS integration, conduit, pits, and detector loops. Working around busy arterial roads — night works likely.',
    estimatedValue: 420000, status: 'ESTIMATING',
    assignedEstimatorId: 'u2', assignedEstimatorName: 'Jane PM',
    linkedJobId: null, linkedJobNumber: null,
    notes: 'TMR have flagged they want to see traffic staging plan in the quote.',
  },
  {
    id: 'sb2', briefNumber: 'SB-2026-009',
    title: 'Underwood Rd Streetlighting Upgrade — Stage 4 (18 luminaires)',
    clientId: 'c2', clientName: 'Brisbane City Council', receivedFrom: 'Paul Smith',
    receivedDate: '2026-06-08', submissionDeadline: '2026-07-10',
    method: 'EMAIL', siteAddress: 'Underwood Rd, Rochedale QLD 4123',
    description: 'Replacement of 18 HPS streetlight luminaires with 80W LED. 4 columns to be replaced. Work under BCC SOA panel.',
    estimatedValue: 185000, status: 'QUOTED',
    assignedEstimatorId: 'u2', assignedEstimatorName: 'Jane PM',
    linkedJobId: null, linkedJobNumber: null,
    notes: 'Quote sent 25 Jun. BCC SOA schedule of rates applies for column replacement.',
  },
  {
    id: 'sb3', briefNumber: 'SB-2026-010',
    title: 'South East Freeway — ITS Cabinet Replacement (12 sites)',
    clientId: 'c1', clientName: 'TMR Region 2', receivedFrom: 'Sarah Jones',
    receivedDate: '2026-05-15', submissionDeadline: '2026-06-20',
    method: 'PORTAL', siteAddress: 'South East Freeway, Brisbane QLD',
    description: 'Replacement of 12 ITS field equipment cabinets. New Advantech embedded controllers, wiring, and SCATS cabinet configuration. Night works required throughout.',
    estimatedValue: 760000, status: 'SUBMITTED',
    assignedEstimatorId: 'u2', assignedEstimatorName: 'Jane PM',
    linkedJobId: null, linkedJobNumber: null,
    notes: 'Submitted 19 Jun. Evaluation period 4 weeks. Strong competition from Downer and Ventia.',
  },
  {
    id: 'sb4', briefNumber: 'SB-2026-006',
    title: 'Musgrave Park — Feature Park Lighting Upgrade',
    clientId: 'c2', clientName: 'Brisbane City Council', receivedFrom: 'Paul Smith',
    receivedDate: '2026-05-01', submissionDeadline: '2026-06-01',
    method: 'EMAIL', siteAddress: 'Musgrave Park, South Brisbane QLD 4101',
    description: 'Feature LED park lighting — 14 bollards, 6 poles, 2 x feature uplights. Design and construct.',
    estimatedValue: 82000, status: 'WON',
    assignedEstimatorId: 'u2', assignedEstimatorName: 'Jane PM',
    linkedJobId: 'j5', linkedJobNumber: 'TP-2026-005',
    notes: 'Awarded 12 Jun. Converted to job TP-2026-005.',
  },
  {
    id: 'sb5', briefNumber: 'SB-2026-011',
    title: 'Ashgrove Ave / Waterworks Rd — Ped Crossing Upgrade',
    clientId: 'c2', clientName: 'Brisbane City Council', receivedFrom: 'Paul Smith',
    receivedDate: '2026-06-14', submissionDeadline: '2026-07-25',
    method: 'VERBAL', siteAddress: 'Ashgrove Ave & Waterworks Rd, Ashgrove QLD 4060',
    description: 'Upgrade 2 pedestrian crossings to HAWK signals. New PPBs, heads, conduit, and pits.',
    estimatedValue: 118000, status: 'RECEIVED',
    assignedEstimatorId: 'u2', assignedEstimatorName: 'Jane PM',
    linkedJobId: null, linkedJobNumber: null,
    notes: 'Go/no-go decision required by 20 Jun. Resource check with PM first.',
  },
  {
    id: 'sb6', briefNumber: 'SB-2026-005',
    title: 'Wynnum Rd Streetlighting — Stage 2',
    clientId: 'c2', clientName: 'Brisbane City Council', receivedFrom: 'Paul Smith',
    receivedDate: '2026-04-20', submissionDeadline: '2026-05-20',
    method: 'EMAIL', siteAddress: 'Wynnum Rd, Morningside QLD 4170',
    description: 'LED streetlight upgrade 24 luminaires.',
    estimatedValue: 95000, status: 'LOST',
    assignedEstimatorId: 'u2', assignedEstimatorName: 'Jane PM',
    linkedJobId: null, linkedJobNumber: null,
    notes: 'Lost to competitor — price was $18k higher. Review prelims pricing.',
  },
]

// ─────────────────────────────────────────────────────────────────
// ESTIMATES
// ─────────────────────────────────────────────────────────────────
export const MOCK_ESTIMATES = [
  {
    id: 'est1', scopeBriefId: 'sb1', briefNumber: 'SB-2026-008',
    estimateNumber: 'EST-2026-008', revision: 1,
    status: 'REVIEW',
    createdByName: 'Jane PM', createdAt: '2026-06-10',
    materialLines: [
      { id: 'ml1', description: 'Traffic Signal Pole 8m Galvanised',          qty: 4,   unit: 'EA', unitRate: 1850.00, total: 7400,  supplierId: 's4', supplierName: 'Fulton Hogan' },
      { id: 'ml2', description: 'LED Signal Head 3-Aspect 300mm',             qty: 16,  unit: 'EA', unitRate: 420.00,  total: 6720,  supplierId: 's5', supplierName: 'Schneider Electric' },
      { id: 'ml3', description: 'SCATS Traffic Signal Controller (TMR spec)', qty: 1,   unit: 'EA', unitRate: 12500.00,total: 12500, supplierId: 's5', supplierName: 'Schneider Electric' },
      { id: 'ml4', description: 'Pedestrian Push Button Assembly',            qty: 8,   unit: 'EA', unitRate: 285.00,  total: 2280,  supplierId: 's5', supplierName: 'Schneider Electric' },
      { id: 'ml5', description: '6mm Twin + Earth Power Cable',               qty: 350, unit: 'm',  unitRate: 4.80,    total: 1680,  supplierId: 's1', supplierName: 'Rexel Electrical' },
      { id: 'ml6', description: 'Signal Interconnect Cable 4-pair',           qty: 400, unit: 'm',  unitRate: 6.50,    total: 2600,  supplierId: 's2', supplierName: 'Anixter' },
      { id: 'ml7', description: '100mm HDPE Conduit',                         qty: 180, unit: 'm',  unitRate: 8.50,    total: 1530,  supplierId: 's4', supplierName: 'Fulton Hogan' },
      { id: 'ml8', description: '450x450 Concrete Pit with Lid',              qty: 12,  unit: 'EA', unitRate: 320.00,  total: 3840,  supplierId: 's4', supplierName: 'Fulton Hogan' },
      { id: 'ml9', description: 'Vehicle Loop Detector (slot in road)',        qty: 8,   unit: 'EA', unitRate: 480.00,  total: 3840,  supplierId: 's5', supplierName: 'Schneider Electric' },
    ],
    labourLines: [
      { id: 'll1', description: 'Electrician A-grade — install & test',    tradeCategory: 'ELECTRICAL_A_GRADE',     hours: 220, workers: 2, hourlyRate: 43.00, total: 18920 },
      { id: 'll2', description: 'Traffic Controller — TMP implementation', tradeCategory: 'TRAFFIC_CONTROLLER',     hours: 200, workers: 2, hourlyRate: 35.50, total: 14200 },
      { id: 'll3', description: 'Apprentice Year 3 — assist electricians', tradeCategory: 'ELECTRICAL_APPRENTICE_3',hours: 180, workers: 1, hourlyRate: 29.00, total: 5220 },
      { id: 'll4', description: 'Site Manager — supervision & QA',         tradeCategory: 'SITE_MANAGER',           hours: 160, workers: 1, hourlyRate: 58.00, total: 9280 },
    ],
    subcontractorLines: [
      { id: 'sl1', subcontractorName: 'Road Access Solutions', scope: 'TMC traffic management coordination and TMP design', quotedAmount: 8500, quoteReference: 'RAS-Q2026-0089' },
      { id: 'sl2', subcontractorName: 'Specialist Loop QLD',  scope: 'Road saw cutting and loop detector installation',     quotedAmount: 6800, quoteReference: 'SLQ-2026-0041' },
    ],
    preliminaries: [
      { id: 'pl1', description: 'Traffic management equipment hire (barriers, signs)', amount: 11500, basis: 'LUMP_SUM' },
      { id: 'pl2', description: 'Site establishment and camp (temporary)',              amount: 2800,  basis: 'LUMP_SUM' },
      { id: 'pl3', description: 'Project insurances — contract works and PL uplift',   amount: 4200,  basis: 'LUMP_SUM' },
      { id: 'pl4', description: 'SCATS commissioning support (TMR technician time)',   amount: 3500,  basis: 'LUMP_SUM' },
    ],
    marginPercent: 14.5, contingencyPercent: 5.0,
    exclusions: [
      'Civil roadworks beyond pit excavation and backfill',
      'Asphalt reinstatement (provisional sum held by TMR)',
      'Energex supply authority works',
      'Geotechnical investigation',
    ],
    assumptions: [
      'Normal working hours Mon–Fri unless noted (night works priced separately in variation allowance)',
      'TMR to provide SCATS system drawings and node number',
      'All utility service plans accurate as issued in brief',
      'No rock encountered in excavation',
    ],
    notes: 'Revision 1 — added loop detector allowance after site visit 12 Jun. Needs MD review before submission.',
  },
  {
    id: 'est2', scopeBriefId: 'sb2', briefNumber: 'SB-2026-009',
    estimateNumber: 'EST-2026-009', revision: 1,
    status: 'APPROVED',
    createdByName: 'Jane PM', createdAt: '2026-06-15',
    materialLines: [
      { id: 'ml10', description: 'LED Streetlight 80W',         qty: 18,  unit: 'EA', unitRate: 620,  total: 11160, supplierId: 's5', supplierName: 'Schneider Electric' },
      { id: 'ml11', description: 'Light Column 8m Powder Coat', qty: 4,   unit: 'EA', unitRate: 980,  total: 3920,  supplierId: 's4', supplierName: 'Fulton Hogan' },
      { id: 'ml12', description: '6mm Power Cable',             qty: 200, unit: 'm',  unitRate: 4.80, total: 960,   supplierId: 's1', supplierName: 'Rexel Electrical' },
    ],
    labourLines: [
      { id: 'll5', description: 'Electrician A-grade', tradeCategory: 'ELECTRICAL_A_GRADE', hours: 80, workers: 2, hourlyRate: 43.00, total: 6880 },
      { id: 'll6', description: 'Traffic Controller',  tradeCategory: 'TRAFFIC_CONTROLLER', hours: 80, workers: 1, hourlyRate: 35.50, total: 2840 },
    ],
    subcontractorLines: [],
    preliminaries: [
      { id: 'pl5', description: 'Traffic management equipment hire', amount: 3500, basis: 'LUMP_SUM' },
    ],
    marginPercent: 15.0, contingencyPercent: 3.0,
    exclusions: ['Asphalt reinstatement'],
    assumptions: ['BCC SOA rates apply to column replacement'],
    notes: 'Approved and submitted to BCC 25 Jun.',
  },
]

// ─────────────────────────────────────────────────────────────────
// CONTRACTS (con1-con4, linked to jobs j1/j2/j4/j5)
// ─────────────────────────────────────────────────────────────────
export const MOCK_CONTRACTS = [
  {
    id: 'con1', jobId: 'j1', jobNumber: 'TP-2026-001',
    contractNumber: 'NWSQ-MSCL-23-0042',
    clientName: 'TMR Region 2', superintendentName: 'Sarah Jones', superintendentPhone: '07 3066 8800',
    contractType: 'AS2124',
    originalContractValue: 385000, approvedVariationsValue: 18450,
    retentionPercent: 5, retentionHeld: 16433,
    awardDate: '2026-04-15', commencementDate: '2026-05-01',
    practicalCompletionDate: '2026-08-15', practicalCompletionActual: null,
    defectsLiabilityMonths: 12, liquidatedDamagesRate: 1500, liquidatedDamagesActive: false,
    bondRequired: false, bondValue: null, bondExpiry: null,
    notes: 'Progress claims due last business day of month.',
  },
  {
    id: 'con2', jobId: 'j2', jobNumber: 'TP-2026-002',
    contractNumber: 'TMR-R2-2026-0018',
    clientName: 'TMR Region 2', superintendentName: 'Sarah Jones', superintendentPhone: '07 3066 8800',
    contractType: 'AS4000',
    originalContractValue: 520000, approvedVariationsValue: 0,
    retentionPercent: 5, retentionHeld: 19500,
    awardDate: '2026-05-28', commencementDate: '2026-06-15',
    practicalCompletionDate: '2026-09-30', practicalCompletionActual: null,
    defectsLiabilityMonths: 12, liquidatedDamagesRate: 2000, liquidatedDamagesActive: false,
    bondRequired: true, bondValue: 52000, bondExpiry: '2027-01-15',
    notes: 'Performance bond required within 14 days of award.',
  },
  {
    id: 'con3', jobId: 'j4', jobNumber: 'TP-2026-004',
    contractNumber: 'ENERGEX-HV-2026-0004',
    clientName: 'Energex', superintendentName: 'Brett Turner', superintendentPhone: '07 3664 4000',
    contractType: 'NEC4',
    originalContractValue: 210000, approvedVariationsValue: 0,
    retentionPercent: 5, retentionHeld: 10500,
    awardDate: '2026-06-05', commencementDate: '2026-06-20',
    practicalCompletionDate: '2026-07-31', practicalCompletionActual: null,
    defectsLiabilityMonths: 6, liquidatedDamagesRate: 1000, liquidatedDamagesActive: false,
    bondRequired: false, bondValue: null, bondExpiry: null,
    notes: 'NEC4 — early warning notices required. CE notification within 8 weeks.',
  },
  {
    id: 'con4', jobId: 'j5', jobNumber: 'TP-2026-005',
    contractNumber: 'BCC-STREET-PANEL-2025',
    clientName: 'Brisbane City Council', superintendentName: 'Paul Smith', superintendentPhone: '07 3403 8888',
    contractType: 'PANEL_SOA',
    originalContractValue: 178000, approvedVariationsValue: 0,
    retentionPercent: 5, retentionHeld: 8900,
    awardDate: '2026-05-01', commencementDate: '2026-05-15',
    practicalCompletionDate: '2026-07-15', practicalCompletionActual: null,
    defectsLiabilityMonths: 12, liquidatedDamagesRate: 500, liquidatedDamagesActive: false,
    bondRequired: false, bondValue: null, bondExpiry: null,
    notes: 'Work order under BCC streetlighting SOA panel.',
  },
]

// ─────────────────────────────────────────────────────────────────
// VARIATIONS — today 2026-06-17
// vr1 APPROVED · vr2 DRAFT (notice 24 Jun = 7d) · vr3 SUBMITTED (notice 1 Jul = 14d) · vr4 DRAFT (notice 20 Jun = 3d URGENT)
// ─────────────────────────────────────────────────────────────────
export const MOCK_VARIATIONS = [
  {
    id: 'vr1', variationNumber: 'VR-001', contractId: 'con1', jobId: 'j1', jobNumber: 'TP-2026-001',
    description: 'Night works required — controller cabinet location change directed by TMR',
    type: 'DIRECTED_VARIATION',
    noticeIssuedDate: '2026-05-28', noticeDueDate: '2026-06-10',
    totalExGST: 18450, gstAmount: 1845, totalIncGST: 20295,
    submittedDate: '2026-06-01', clientResponse: 'APPROVED', approvedAmount: 18450,
    status: 'APPROVED',
    costLines: [
      { description: 'Night work penalty rates (20 electrician shifts)', amount: 9200 },
      { description: 'Traffic management — night TMP and TC penalties',  amount: 5800 },
      { description: 'Generator hire and lighting towers (4 nights)',    amount: 3450 },
    ],
  },
  {
    id: 'vr2', variationNumber: 'VR-002', contractId: 'con3', jobId: 'j4', jobNumber: 'TP-2026-004',
    description: 'HV straight joint design changed from PILC to XLPE termination by Energex Engineering',
    type: 'CLIENT_INSTRUCTION',
    noticeIssuedDate: null, noticeDueDate: '2026-06-24',
    totalExGST: 12800, gstAmount: 1280, totalIncGST: 14080,
    submittedDate: null, clientResponse: 'PENDING', approvedAmount: null,
    status: 'DRAFT',
    costLines: [
      { description: 'XLPE termination kits (2 sets) vs PILC (price difference)', amount: 4200 },
      { description: 'Additional HV jointing labour — revised technique',           amount: 6400 },
      { description: 'Energex type test documentation preparation',                  amount: 2200 },
    ],
  },
  {
    id: 'vr3', variationNumber: 'VR-003', contractId: 'con2', jobId: 'j2', jobNumber: 'TP-2026-002',
    description: 'Additional loop detectors required at ramp nose — not in original scope',
    type: 'CHANGED_CONDITIONS',
    noticeIssuedDate: '2026-06-15', noticeDueDate: '2026-07-01',
    totalExGST: 9600, gstAmount: 960, totalIncGST: 10560,
    submittedDate: '2026-06-16', clientResponse: 'PENDING', approvedAmount: null,
    status: 'SUBMITTED',
    costLines: [
      { description: '2 x additional loop detector circuits + saw cutting', amount: 6200 },
      { description: 'Controller programming update',                       amount: 1800 },
      { description: 'Additional traffic management for loop installation', amount: 1600 },
    ],
  },
  {
    id: 'vr4', variationNumber: 'VR-004', contractId: 'con1', jobId: 'j1', jobNumber: 'TP-2026-001',
    description: 'Pole 3 location shift 4m south — conflict with Telstra pits found on site',
    type: 'CHANGED_CONDITIONS',
    noticeIssuedDate: null, noticeDueDate: '2026-06-20',
    totalExGST: 3200, gstAmount: 320, totalIncGST: 3520,
    submittedDate: null, clientResponse: 'PENDING', approvedAmount: null,
    status: 'DRAFT',
    costLines: [
      { description: 'Additional conduit and cabling to revised pole position', amount: 1800 },
      { description: 'Foundation redesign and relocated pit',                   amount: 1400 },
    ],
  },
]

// ─────────────────────────────────────────────────────────────────
// PROGRESS CLAIMS
// ─────────────────────────────────────────────────────────────────
export const MOCK_PROGRESS_CLAIMS = [
  {
    id: 'pc1', claimNumber: 1, contractId: 'con1', jobId: 'j1', jobNumber: 'TP-2026-001',
    claimPeriodFrom: '2026-05-01', claimPeriodTo: '2026-05-31', claimDate: '2026-05-31',
    workCompletedThisClaim: 91250, workCompletedToDate: 91250, contractValue: 385000,
    percentComplete: 23.7, retentionThisClaim: 4563, retentionToDate: 4563,
    previouslyCertified: 0, thisClaimNet: 86687, gst: 8669, totalIncGST: 95356,
    certifiedAmount: 86250, certifiedDate: '2026-06-07', certifiedBy: 'Sarah Jones',
    paymentDueDate: '2026-06-21', paymentReceivedDate: '2026-06-20', paymentReceivedAmount: 94875,
    status: 'PAID',
  },
  {
    id: 'pc2', claimNumber: 1, contractId: 'con3', jobId: 'j4', jobNumber: 'TP-2026-004',
    claimPeriodFrom: '2026-06-20', claimPeriodTo: '2026-06-30', claimDate: '2026-06-30',
    workCompletedThisClaim: 126000, workCompletedToDate: 126000, contractValue: 210000,
    percentComplete: 60.0, retentionThisClaim: 6300, retentionToDate: 6300,
    previouslyCertified: 0, thisClaimNet: 119700, gst: 11970, totalIncGST: 131670,
    certifiedAmount: 126000, certifiedDate: '2026-07-07', certifiedBy: 'Brett Turner (Energex)',
    paymentDueDate: '2026-07-21', paymentReceivedDate: null, paymentReceivedAmount: null,
    status: 'CERTIFIED',
  },
  {
    id: 'pc3', claimNumber: 2, contractId: 'con1', jobId: 'j1', jobNumber: 'TP-2026-001',
    claimPeriodFrom: '2026-06-01', claimPeriodTo: '2026-06-30', claimDate: '2026-06-30',
    workCompletedThisClaim: 80800, workCompletedToDate: 172050, contractValue: 403450,
    percentComplete: 42.6, retentionThisClaim: 4040, retentionToDate: 8603,
    previouslyCertified: 86250, thisClaimNet: 76760, gst: 7676, totalIncGST: 84436,
    certifiedAmount: null, certifiedDate: null, certifiedBy: null,
    paymentDueDate: null, paymentReceivedDate: null, paymentReceivedAmount: null,
    status: 'DRAFT',
  },
  {
    id: 'pc4', claimNumber: 1, contractId: 'con2', jobId: 'j2', jobNumber: 'TP-2026-002',
    claimPeriodFrom: '2026-06-15', claimPeriodTo: '2026-06-30', claimDate: '2026-06-30',
    workCompletedThisClaim: 78000, workCompletedToDate: 78000, contractValue: 520000,
    percentComplete: 15.0, retentionThisClaim: 3900, retentionToDate: 3900,
    previouslyCertified: 0, thisClaimNet: 74100, gst: 7410, totalIncGST: 81510,
    certifiedAmount: null, certifiedDate: null, certifiedBy: null,
    paymentDueDate: null, paymentReceivedDate: null, paymentReceivedAmount: null,
    status: 'SUBMITTED',
  },
]

// ─────────────────────────────────────────────────────────────────
// EOT CLAIMS
// ─────────────────────────────────────────────────────────────────
export const MOCK_EOT_CLAIMS = [
  {
    id: 'eot1', claimNumber: 'EOT-2026-001', contractId: 'con3', jobId: 'j4', jobNumber: 'TP-2026-004',
    delayEvent: 'Energex switching programme delay — mandatory 45-min wait imposed by network control',
    delayEventDate: '2026-06-17', noticeIssuedDate: '2026-06-17',
    daysClaimedExtension: 1,
    evidenceTypes: ['Site diary SD3 — 17 Jun 2026', 'Energex switching log reference ESP-2026-0412'],
    status: 'SUBMITTED', approvedDays: null, newContractualCompletionDate: null,
    notes: 'Even though 1 day, important to claim to protect LD position if delays compound.',
  },
]

// ─────────────────────────────────────────────────────────────────
// HELPER FUNCTIONS
// ─────────────────────────────────────────────────────────────────
export function calcEstimateTotals(est: typeof MOCK_ESTIMATES[0]) {
  const matTotal  = est.materialLines.reduce((s, l) => s + l.total, 0)
  const labTotal  = est.labourLines.reduce((s, l) => s + l.total, 0)
  const subTotal  = est.subcontractorLines.reduce((s, l) => s + l.quotedAmount, 0)
  const prelTotal = est.preliminaries.reduce((s, l) => s + l.amount, 0)
  const subtotal  = matTotal + labTotal + subTotal + prelTotal
  const marginAmt = subtotal * (est.marginPercent / 100)
  const contAmt   = (subtotal + marginAmt) * (est.contingencyPercent / 100)
  const totalExGST = subtotal + marginAmt + contAmt
  const gst        = totalExGST * 0.1
  return { matTotal, labTotal, subTotal, prelTotal, subtotal, marginAmt, contAmt, totalExGST, gst, totalIncGST: totalExGST + gst }
}

export function getVariationNoticeDaysLeft(vr: typeof MOCK_VARIATIONS[0]) {
  if (!vr.noticeDueDate) return null
  const today = new Date('2026-06-17')
  const due   = new Date(vr.noticeDueDate)
  return Math.ceil((due.getTime() - today.getTime()) / 86400000)
}

export function getNoticeUrgency(daysLeft: number | null): 'OK' | 'WARN' | 'URGENT' | 'MISSED' {
  if (daysLeft === null) return 'OK'
  if (daysLeft < 0)  return 'MISSED'
  if (daysLeft <= 3) return 'URGENT'
  if (daysLeft <= 7) return 'WARN'
  return 'OK'
}

export const BRIEF_STATUS_META: Record<string, { label: string; bg: string; text: string; dot: string; order: number }> = {
  RECEIVED:   { label: 'Received',   bg: 'bg-gray-100',   text: 'text-gray-600',   dot: 'bg-gray-400',  order: 1 },
  ESTIMATING: { label: 'Estimating', bg: 'bg-blue-100',   text: 'text-blue-700',   dot: 'bg-blue-500',  order: 2 },
  QUOTED:     { label: 'Quoted',     bg: 'bg-purple-100', text: 'text-purple-700', dot: 'bg-purple-500',order: 3 },
  SUBMITTED:  { label: 'Submitted',  bg: 'bg-amber-100',  text: 'text-amber-700',  dot: 'bg-amber-500', order: 4 },
  WON:        { label: 'Won',        bg: 'bg-green-100',  text: 'text-green-700',  dot: 'bg-green-500', order: 5 },
  LOST:       { label: 'Lost',       bg: 'bg-red-100',    text: 'text-red-700',    dot: 'bg-red-400',   order: 6 },
  NO_QUOTE:   { label: 'No quote',   bg: 'bg-gray-100',   text: 'text-gray-500',   dot: 'bg-gray-300',  order: 7 },
}

export const CONTRACT_TYPE_META: Record<string, { label: string; color: string }> = {
  NEC4:      { label: 'NEC4',      color: 'text-purple-700' },
  AS2124:    { label: 'AS2124',    color: 'text-blue-700' },
  AS4000:    { label: 'AS4000',    color: 'text-indigo-700' },
  PANEL_SOA: { label: 'SOA Panel', color: 'text-teal-700' },
  LUMP_SUM:  { label: 'Lump sum',  color: 'text-gray-600' },
  COST_PLUS: { label: 'Cost plus', color: 'text-orange-700' },
}

export const CLAIM_STATUS_META: Record<string, { label: string; bg: string; text: string }> = {
  DRAFT:     { label: 'Draft',     bg: 'bg-gray-100',  text: 'text-gray-600' },
  SUBMITTED: { label: 'Submitted', bg: 'bg-blue-100',  text: 'text-blue-700' },
  CERTIFIED: { label: 'Certified', bg: 'bg-amber-100', text: 'text-amber-700' },
  PAID:      { label: 'Paid',      bg: 'bg-green-100', text: 'text-green-700' },
  DISPUTED:  { label: 'Disputed',  bg: 'bg-red-100',   text: 'text-red-700' },
}
